import * as React from "react";
import IHeaderProps from "./IHeader";
import { connect  } from "react-redux";
import { withRouter } from "react-router";
// import { Redirect } from "react-router-dom";
import { bindActionCreators, compose } from "redux";
// import { createBrowserHistory } from "history";
import * as adminActionCreators from "../AdminDashboard/actionCreators";
import * as draftListActionCreators from "../DraftRegistration/actionCreators";
import * as globalActionsCreators from "../../globalStore/actions";
import constantFile from "../../constants/constantFile";
import AlertMessage from "../../widgets/AlertMessageWidget";
import { getCustomerIDFromStore, checkSuperAdminAccess, getAllParameters } from "../../utils/utils";
import * as TransactionActionCreator from "../ThankYou/actionCreators";
import {
    setCCzPopup,
    getCCzPopup,
    setDashboardPopup,
    getDashboardPopup,
    removeWindowBeforeUnload,
    imagePathurl,
} from "../../utils/utils";
import * as dynamicFormActionCreators from "../../components/DynamicForm/actionCreators";
import * as submittedListActionCreators from "../SubmittedWarranties/actionCreators";
import ExistApp from "../ExitAppPopup";
import * as CONFIG from "../../../config.json";
import ReactGA from "react-ga";
import "../../../assets/sass/components/header.scss";

// const history = createBrowserHistory();

interface HeaderStateProps {
    hambugrgerMenuVisible?: any;
    navigateDashboardPopUp?: any;
    cczPopup?: any;
    checked?: any;
    showHeaderImage?: any;
    navigatebackPopUp?: any;
    redirectTo?: any;
}
class Header extends React.Component<IHeaderProps, HeaderStateProps, {}> {
    constructor(props) {
        super(props);
        this.state = {
            hambugrgerMenuVisible: false,
            navigateDashboardPopUp: false,
            cczPopup: false,
            checked: false,
            showHeaderImage: false,
            navigatebackPopUp: false,
            redirectTo: "",
        };
        this.hambugrgerMenuClick = this.hambugrgerMenuClick.bind(this);
        this.onDashboardPopupClick = this.onDashboardPopupClick.bind(this);
        this.onDashboardNavigateClick = this.onDashboardNavigateClick.bind(this);
        this.onDashboardPopupClose = this.onDashboardPopupClose.bind(this);
        this.onContactGafClick = this.onContactGafClick.bind(this);
        this.onCczClick = this.onCczClick.bind(this);
        this.hidePopUp = this.hidePopUp.bind(this);
        this.backToAdmin = this.backToAdmin.bind(this);
        this.navigatebackPopUpClose = this.navigatebackPopUpClose.bind(this);
    }
    componentDidMount() {
        setCCzPopup(getCCzPopup());
        setDashboardPopup(getDashboardPopup());
    }
    componentDidUpdate(prevProps, nextState) {
        if (prevProps.userInfo !== this.props.userInfo && !this.props.userInfo.isAdmin && !this.props.userInfo.isTm) {
            this.setState({ showHeaderImage: true });
        }
    }
    /*conformation popup visible method */
    onDashboardPopupClick = () => {
        window["AppInsightTrace"].trackEvent(`on dash board popup click`);
        const {
            formId,
            formData,
            warrantyId,
            dynamicFormActions: { saveDraftForm, updateDraftForm, validateBuildingAddress },
            submittedListActions: { updateActiveTab, resetSubmittedWarrantyList },
        } = this.props;
        updateActiveTab("draft");
        resetSubmittedWarrantyList();
        if (window.location.href.includes("myCart")){
            this.clearAdminData(false, "draftList");
            const navigateToUrl = getAllParameters(this.props.userInfo);
            this.props.history.push(navigateToUrl);
            return;
        }
        const successCallBacktoDraftList = () => {
            this.props.draftListActions.fetchDraftWarrentyList();
            this.clearAdminData(false, "draftList");
        };
        if (this.props.transactionData) {
            this.setState({
                navigateDashboardPopUp: false,
            });
            this.onDashboardNavigateClick();
        } else {
            const validateBillAddCbk = (status) => {
                if (status) {
                    if (this.props.warrantyId) {
                        updateDraftForm({
                            payload: {
                                Id: warrantyId,
                                formData: formData,
                                successCallBack: successCallBacktoDraftList,
                                failureCallback: successCallBacktoDraftList,
                            },
                        });
                    } else {
                        if (formData && Object.keys(formData).length > 0) {
                            saveDraftForm({
                                payload: {
                                    Id: formId,
                                    formData: formData,
                                    successCallBack: successCallBacktoDraftList,
                                    failureCallback: successCallBacktoDraftList,
                                },
                            });
                        }
                    }
                }
            };
            if (getDashboardPopup()) {
                if (this.props.isSubmittedForm) {
                    successCallBacktoDraftList();
                } else {
                    validateBuildingAddress({ successCallback: validateBillAddCbk });
                }
            } else {
                this.setState({
                    navigateDashboardPopUp: true,
                });
                document.body.classList.add("hideOverflow");
            }
        }
    };
    handleCLick = (e) => {
        this.setState({
            checked: !this.state.checked,
        });
    };
    /*Redirect to dashborad page method */
    onDashboardNavigateClick = () => {
        this.clearToasterMsges();
        const {
            paymentActions: { updateIsAlreadyPaymentInitiated },
            submittedListActions: { updateActiveTab, resetSubmittedWarrantyList },
        } = this.props;
        updateActiveTab("draft");
        resetSubmittedWarrantyList();
        if (window.location.href.includes("myCart")){
            this.clearAdminData(false, "draftList");
            updateIsAlreadyPaymentInitiated();
            const navigateToUrl = getAllParameters(this.props.userInfo);
            this.props.history.push(navigateToUrl);
            return;
        }
        if (this.props.transactionData) {
            updateIsAlreadyPaymentInitiated();
            const customerId = decodeURIComponent(getCustomerIDFromStore(true));
            const path = customerId ? `/?customerID=${customerId}` : "/?provider=okta";
            window.location.replace(path);
        } else {
            this.setState(
                {
                    navigateDashboardPopUp: !this.state.navigateDashboardPopUp,
                    hambugrgerMenuVisible: !this.state.hambugrgerMenuVisible,
                },
                () => {
                    document.body.classList.remove("hideOverflow");
                    const { formData, formId, warrantyId } = this.props;
                    const { saveDraftForm, updateDraftForm, validateBuildingAddress } = this.props.dynamicFormActions;
                    setDashboardPopup(this.state.checked);
                    const successCallBack = () => {
                        this.props.draftListActions.fetchDraftWarrentyList();
                        this.clearAdminData(false, "draftList");
                    };
                    const validateBillSuccss = (status) => {
                        if (status) {
                            if (this.props.warrantyId) {
                                updateDraftForm({
                                    payload: {
                                        Id: warrantyId,
                                        formData: formData,
                                        successCallBack: successCallBack,
                                        failureCallback: successCallBack,
                                    },
                                });
                            } else {
                                if (formData && Object.keys(formData).length > 0) {
                                    saveDraftForm({
                                        payload: {
                                            Id: formId,
                                            formData: formData,
                                            successCallBack: successCallBack,
                                            failureCallback: successCallBack,
                                        },
                                    });
                                } else {
                                    successCallBack();
                                }
                            }
                        } else {
                            successCallBack();
                        }
                    };
                    if (this.props.isSubmittedForm) {
                        successCallBack();
                    } else {
                        validateBuildingAddress({ successCallback: validateBillSuccss });
                    }
                    const tabElement = document.querySelector(".nav-menu-item.active div.nav-label");
                    const currTab = (tabElement && tabElement.textContent) || "";
                    ReactGA.event({
                        category: "Visit Dashboard",
                        action: `Visit Dashboard: ${currTab}`,
                        label: `Visit Dashboard: ${currTab}`,
                    });
                }
            );
        }
    };
    /*mobile hamburger toggle menu */
    hambugrgerMenuClick(e) {
        e.stopPropagation();
        window["AppInsightTrace"].trackEvent("on hamburger menu click (mobile)");
        if (this.props.screenResolution.width < 767) {
            if (!this.state.hambugrgerMenuVisible) {
                document.body.classList.add("hideOverflow");
            } else {
                document.body.classList.remove("hideOverflow");
            }
            this.setState({
                hambugrgerMenuVisible: !this.state.hambugrgerMenuVisible,
            });
        }
    }
    /*conformation popup close method */
    onDashboardPopupClose() {
        this.setState({
            navigateDashboardPopUp: !this.state.navigateDashboardPopUp,
        });
        document.body.classList.remove("hideOverflow");
    }
    onContactGafClick() {
        this.props.dynamicFormActions.toggleTechSupportPopUp(true);
        window["AppInsightTrace"].trackEvent("on contact GAF click");
        if (this.props.screenResolution.width <= 767) {
            document.body.classList.add("hideOverflow");
        }
    }
    handlePopupClose() {
        this.props.dynamicFormActions.toggleTechSupportPopUp();
        window["AppInsightTrace"].trackEvent("on popup close click");
        document.body.classList.remove("hideOverflow");
    }
    onCczClick() {
        const { formData, formId, warrantyId } = this.props;
        const {
            saveDraftForm,
            updateDraftForm,
            updateBillingAddressStatus,
            validateBuildingAddress,
        } = this.props.dynamicFormActions;
        const isNewForm = this.isNewForm();
        const cczlink = `${CONFIG["CONFIG"].cczLink}`;
        const successCallBackUpdate = () => {
            removeWindowBeforeUnload();
            window.open(cczlink, "_self");
        };
        if (window.location.href.includes("myCart")){
            this.setState({
                cczPopup: false,
            });
            successCallBackUpdate();
            return;
        }
        const failureCallback = (data) => {};
        if (this.props.transactionData) {
            this.setState({
                cczPopup: false,
            });
            removeWindowBeforeUnload();
            window.open(cczlink, "_self");
        } else {
            const validateBillAddrCbk = (status) => {
                updateBillingAddressStatus({ payload: status });
                if (status) {
                    if (warrantyId) {
                        updateDraftForm({
                            payload: {
                                Id: warrantyId,
                                formData: formData,
                                successCallBack: successCallBackUpdate,
                                failureCallback: failureCallback,
                            },
                        });
                    } else {
                        saveDraftForm({
                            payload: {
                                Id: formId,
                                formData: formData,
                                successCallBack: successCallBackUpdate,
                                failureCallback: failureCallback,
                            },
                        });
                    }
                } else {
                    updateBillingAddressStatus({ payload: status });
                }
            };
            if (getCCzPopup() || !isNewForm) {
                if (isNewForm && !this.props.isSubmittedForm) {
                    validateBuildingAddress({ successCallback: validateBillAddrCbk });
                } else {
                    successCallBackUpdate();
                }
            } else {
                this.setState({
                    cczPopup: true,
                });
                document.body.classList.add("hideOverflow");
            }
        }
    }
    isNewForm() {
        const { userInfo, contractorSelection } = this.props;
        if (this.props.activeScreen == "NewForm") {
            if (
                (userInfo && contractorSelection && (userInfo.isAdmin || userInfo.isTm) && contractorSelection.contractorId) ||
                (!userInfo.isAdmin && !userInfo.isTm)
            ) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
    hidePopUp() {
        this.setState({
            cczPopup: false,
        });
        document.body.classList.remove("hideOverflow");
    }
    navigatebackPopUpClose() {
        this.setState({ navigatebackPopUp: !this.state.navigatebackPopUp });
    }
    goToAdmin = () => {
        this.props.paymentActions.removeContractorIdFromPersistData();
        this.props.paymentActions.updateIsAlreadyPaymentInitiated();
        if (this.props.transactionData) {
            const customerId = getCustomerIDFromStore(true);
            const path = customerId ? `/?customerID=${customerId}` : "/?provider=okta";
            window.location.replace(path);
        } else if (this.props.isSubmittedForm) {
            if (getDashboardPopup()) {
                this.setState({
                    navigatebackPopUp: false,
                });
                this.backToAdmin();
            } else {
                this.setState({ navigatebackPopUp: true });
            }
        } else {
            this.backToAdmin();
        }

        // history.goBack();
        // return <Redirect to={`/`} />;
        // history.push(`/?contractorId=${userInfo.contractorId}`);
    };
    clearAdminData = (clearContractor, form) => {
        const {
            draftListActions: { fetchDraftWarrentyListsuccess },
            adminActions: {
                updateReceivedDate,
                updateWaiverReceived,
                updateContractorSelection,
                updateFormSubmittedStatus,
            },
            paymentActions: { updateIsAlreadyPaymentInitiated },
        } = this.props;
        this.props.globalActions.updateActiveScreen(form);
        this.props.dynamicFormActions.removeFormLayoutData({ payload: true });
        updateIsAlreadyPaymentInitiated();
        updateReceivedDate(undefined);
        updateWaiverReceived(false);
        updateFormSubmittedStatus(false);
        if (clearContractor) {
            fetchDraftWarrentyListsuccess({ value: [] });
            updateContractorSelection(undefined);
            this.props.dynamicFormActions.SetContractorFormSettings({})
        }
        this.setState({ navigatebackPopUp: false });
        sessionStorage.removeItem("accordions");
    };
    backToAdmin = () => {
        const {
            adminActions: { formData, fetchContractorStatusSuccess },
        } = this.props;
        const { saveDraftForm, updateDraftForm, validateBuildingAddress } = this.props.dynamicFormActions;
        // setDashboardPopup(this.state.checked);
        if (window.location.href.includes("myCart")){
            this.clearAdminData(true, "NewForm");
            fetchContractorStatusSuccess({ payload: {} });
            const navigateToUrl = getAllParameters(this.props.userInfo);
            this.props.history.push(navigateToUrl);
            return;
        }
        const successCallBack = () => {
            this.clearAdminData(true, "NewForm");
        };
        setDashboardPopup(this.state.checked);
        // if (!this.props.isSubmittedForm) {
        const validateBillSuccss = (status) => {
            if (status) {
                if (this.props.warrantyId) {
                    updateDraftForm({
                        payload: {
                            Id: this.props.warrantyId,
                            formData: formData,
                            successCallBack: successCallBack,
                            failureCallback: successCallBack,
                        },
                    });
                } else {
                    if (formData && Object.keys(formData).length > 0) {
                        saveDraftForm({
                            payload: {
                                Id: this.props.formId,
                                formData: formData,
                                successCallBack: successCallBack,
                                failureCallback: successCallBack,
                            },
                        });
                    } else {
                        successCallBack();
                    }
                }
            } else {
                successCallBack();
            }
        };
        if (this.isNewForm() && !this.props.isSubmittedForm) {
            validateBuildingAddress({ successCallback: validateBillSuccss });
        } else {
            successCallBack();
        }
        // }
    };
    goToHomeLink = () => {
        this.clearToasterMsges();
        window.location.replace("/?provider=okta");
    };
    goToSuperAdmin = () => {
        this.setState({
            hambugrgerMenuVisible: false
        });
        this.props.history.push("/superadmin");
    }
    goToOperationalReport = () => {
        this.setState({
            hambugrgerMenuVisible: false
        });
        this.props.history.push("/operationalreport")
    };
    openShopingCart = () => {
        this.setState({
            hambugrgerMenuVisible: false
        });
        this.clearToasterMsges();
        this.props.history.push("/myCart")
    };
    clearToasterMsges = () => {
        this.props.globalActions.clearGlobalSuccessMsg();
        this.props.globalActions.clearGlobalError();
    };
    render() {
        const {
            loading,
            userInfo,
            contractorSelection,
            screenResolution,
            globalActions,
            totalCount,
            successMessage,
            error,
        } = this.props;
        // const faq = location.protocol + "//" + location.hostname + `${CONFIG.faq}`;
        let faq = `${CONFIG["CONFIG"].faq}`;
        const pat = /^https?:\/\//i;
        if (!pat.test(faq)) {
            faq = location.origin + `${CONFIG["CONFIG"].faq}`;
        }
        //image CDN_PATH
        const getimagePath = imagePathurl();
        const isAdmin = userInfo && userInfo.isAdmin;
        const isTm = userInfo && userInfo.isTm;
        const checkBoxVal = this.state.checked;
        const isThankYouPage = window.location.pathname.toLowerCase().includes("paymentsuccess");
        let AdminHeader = null;
        if (userInfo && contractorSelection && (userInfo.isAdmin || isTm) && contractorSelection.contractorId) {
            const { activeStatus, contractorName, contractorId, region } = contractorSelection;
            AdminHeader = contractorSelection && (
                <>
                    {screenResolution.width > 768 ? (
                        <div className="AdminHeader">
                            <div
                                className="customer-redirect"
                                onClick={this.goToAdmin}
                            >{`< BACK TO CUSTOMER LIST`}</div>
                            <div className="customer-details">
                                {`${activeStatus} - ${contractorName} (${contractorId}) - ${region}`}
                            </div>
                        </div>
                    ) : (
                        <div className="AdminHeader">
                            <div className="customer-details">
                                {`${activeStatus} - ${contractorName} (${contractorId}) - ${region}`}
                            </div>
                            <div
                                className="customer-redirect"
                                onClick={this.goToAdmin}
                            >{`< BACK TO CUSTOMER LIST`}</div>
                        </div>
                    )}
                </>
            );
        }
        const isMyCartPage = window.location.href.includes("myCart");
        const isOperationalReportPage = window.location.href.includes('operationalreport');
        const hideFAQ = userInfo && (userInfo.isAdmin || isTm) && !contractorSelection;
        const showOperationalReport = (userInfo && !loading && hideFAQ && (userInfo.isAdmin || isTm)) || isOperationalReportPage;
        const showSuperAdminTab = !loading && hideFAQ && userInfo && checkSuperAdminAccess(userInfo);
        return (
            // imagePath
            <React.Fragment>
                <div className="header">
                    {AdminHeader}
                    <div className="main-header">
                        <div className="GAF-details">
                            <img
                                className={!hideFAQ ? "GAF-logo" : "GAF-admin-logo"}
                                src={`${getimagePath}SteepSlope.png`}
                                alt="GAF-logo"
                            />
                        </div>
                        <div className="header-menu ">
                            <div className={!hideFAQ || showOperationalReport ? "backto-zone" : "admin-backto-zone"}>
                                {this.state.cczPopup && <ExistApp hidePopsUp={this.hidePopUp} />}
                                <div className="d-flex" onClick={() => this.onCczClick()}>
                                    <span>
                                        <img className="ccz-img" src={`${getimagePath}chevron-left.png`} alt="back" />
                                    </span>
                                    <div className="title">Back to GAF Partner Portal</div>
                                </div>
                            </div>
                            {!loading && !isOperationalReportPage && !hideFAQ ? (
                                <div className="bottom-menu">
                                    <div className="faq-right-align">
                                        <a tabIndex={-1} rel="noopener noreferrer" href={faq} target="_blank">
                                            FAQ
                                        </a>
                                    </div>
                                    {(this.props.activeScreen === "NewForm" || !!isMyCartPage) && (
                                        <div className="formsec ml-4" onClick={this.onDashboardPopupClick}>
                                            <div className="dashboard">DASHBOARD</div>
                                        </div>
                                    )}
                                    <div className="formsec ml-4 cart-icon" onClick={this.openShopingCart}>
                                        <img src={`${getimagePath}cart.svg`} alt="Cart" />
                                        {totalCount > 0 && (<span className="badge-counter">{totalCount}</span>)}
                                    </div>
                                </div>
                            ) : null}
                            { showOperationalReport ? (
                                <div className="bottom-menu">
                                    <div className="formsec" onClick={this.goToHomeLink}>
                                        <div className="dashboard">Dashboard</div>
                                    </div>
                                    <div className="formsec ml-4" onClick={this.goToOperationalReport}>
                                        <div className="dashboard">Operational Report</div>
                                    </div>
                                    {showSuperAdminTab ? (
                                        <div className="formsec ml-4" onClick={this.goToSuperAdmin}>
                                            <div className="dashboard">Super Admin</div>
                                        </div>
                                    ): null}
                                </div>
                            ) : null }
                        </div>
                        <div className="hamburger">
                            <div className="mobile-view cart-icon" onClick={this.openShopingCart}>
                                <img src={`${getimagePath}cart.svg`} alt="Cart" />
                                {totalCount > 0 && (<span className="badge-counter">{totalCount}</span>)}
                            </div>
                            <img src={`${getimagePath}hamburger.png`} alt="hamburger" onClick={this.hambugrgerMenuClick} />
                        </div>
                    </div>
                </div>
                {this.state.hambugrgerMenuVisible ? (
                    <div className="mobilemenu">
                        <div className="overlay"></div>
                        <div className="show-hamburger-menuitem">
                            <div className="header-container">
                                <div className="header-title">
                                    {this.state.cczPopup && <ExistApp hidePopsUp={this.hidePopUp} />}
                                    <div className="ccz-menu" onClick={() => this.onCczClick()}>
                                        {/* <span className="backchevron"> */}
                                        <img
                                            className="backchevron-img"
                                            src={`${getimagePath}chevron-left.png`}
                                            alt="back"
                                        />
                                        {/* </span> */}
                                        <span className="title-menu">Back to GAF Partner Portal</span>
                                    </div>
                                    <div className="close-icon" onClick={this.hambugrgerMenuClick}>
                                        <img src={`${getimagePath}menu-close.png`} alt="closemenu" />
                                    </div>
                                </div>
                            </div>
                            { showOperationalReport ? (
                                <>
                                <div className="mobileform-btn pr9 pl8">
                                    <div className="pt15 pl9 pb5 formsec" onClick={this.goToHomeLink}>
                                        <div className="mobile-operational-report dashboard">Dashboard</div>
                                    </div>
                                </div>
                                <div className="menu-items pr9 pl8">
                                    <div className="pt10 pl9 pb5 formsec" onClick={this.goToOperationalReport}>
                                        <div className="mobile-operational-report dashboard">Operational Report</div>
                                    </div>
                                </div>
                                <div className="mobileform-btn pr9 pl8">
                                {showSuperAdminTab ? (
                                    <div className="pt15 pl9 pb5 formsec" onClick={this.goToSuperAdmin}>
                                        <div className="mobile-operational-report dashboard">Super Admin</div>
                                    </div>
                                ): null}
                                </div>
                                </>
                            ) : (this.props.activeScreen === "NewForm" || isMyCartPage) && (
                                <div className="mobileform-btn pr9 pl8 ">
                                    <div className="pt15 pl9 pb5 formsec" onClick={this.onDashboardPopupClick}>
                                        <div className="dashboard">Dashboard</div>
                                    </div>
                                </div>
                            )}
                            <div className="menu-items pr9 pl8">
                                <div className="Faq pt10 pb6 pl9">
                                    <a rel="noopener noreferrer" href={faq} target="_blank">
                                        FAQ
                                    </a>
                                </div>
                                {this.props.screenResolution.width <= 767 && this.props.activeScreen === "NewForm" && (
                                    <div className="contact-gaf pt10 pb6 pl9" onClick={this.onContactGafClick}>
                                        Contact GAF
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                ) : null}
                {this.state.navigateDashboardPopUp ? (
                    <div>
                        <div className="overlay" onClick={this.onDashboardPopupClose}>
                            <div className="popup-container" onClick={(e) => {
                                e.stopPropagation();
                            }}>
                                <div className="close-menu" onClick={this.onDashboardPopupClose}>
                                    <img
                                        tabIndex={10002}
                                        className="popup-close-icon"
                                        src={`${getimagePath}close-mobile.png`}
                                        alt="close"
                                    />
                                </div>
                                {/* <div className="popup-header-title">{constantFile.redirectGenaralTitle}</div> */}
                                <div className="popup-header-subtitle">{constantFile.navigateAwayDescription}</div>
                                <label className={`gaf-dont-show-checkbox  ${checkBoxVal ? "checked" : "unchecked"}`}>
                                    <input
                                        checked={this.state.checked}
                                        type="checkbox"
                                        className="hide-checkbox"
                                        onClick={this.handleCLick}
                                    />
                                </label>
                                <label className="dontshow">{constantFile.navigateCheckboxText}</label>
                                <div className="text-center">
                                    <button
                                        tabIndex={10003}
                                        id="btn_dashboard"
                                        className="popup-btn"
                                        onClick={this.onDashboardNavigateClick}
                                    >
                                        {constantFile.navigateAwayConfirmButtonText}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
                <>
                    {this.state.navigatebackPopUp ? (
                        <div>
                            <div className="overlay" onClick={this.navigatebackPopUpClose}>
                                <div className="popup-container" onClick={(e) => {
                                    e.stopPropagation();
                                }}>
                                    <div className="close-menu" onClick={this.navigatebackPopUpClose}>
                                        <img
                                            tabIndex={10002}
                                            className="popup-close-icon"
                                            src={`${getimagePath}close-mobile.png`}
                                            alt="close"
                                        />
                                    </div>
                                    {/* <div className="popup-header-title">{constantFile.redirectGenaralTitle}</div> */}
                                    <div className="popup-header-subtitle">{constantFile.navigateAwayDescription}</div>
                                    <label
                                        className={`gaf-dont-show-checkbox  ${checkBoxVal ? "checked" : "unchecked"}`}
                                    >
                                        <input
                                            checked={this.state.checked}
                                            type="checkbox"
                                            className="hide-checkbox"
                                            onClick={this.handleCLick}
                                        />
                                    </label>
                                    <label className="dontshow">{constantFile.navigateCheckboxText}</label>
                                    <div className="text-center">
                                        <button
                                            tabIndex={10003}
                                            id="btn_dashboard"
                                            className="popup-btn"
                                            onClick={this.backToAdmin}
                                        >
                                            {constantFile.navigateAwayConfirmButtonText}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null}
                </>
                {!hideFAQ && !isOperationalReportPage && !loading && (
                    <div className={isAdmin || isTm ? "admin-banner-container" : "banner-container"}>
                        {!isThankYouPage ? (
                            <>
                                <div className="banner-title">Warranty registration is just a few steps away</div>
                                <div className="banner">
                                    <div className="banner-content"></div>
                                </div>
                            </>
                        ): null}
                    </div>
                )}
                {(error || successMessage) && (
                    <div className="alert-container">
                        <AlertMessage
                            type={error ? "error" : "success"}
                            message={error || successMessage}
                            closeAlert={error ? globalActions.clearGlobalError : globalActions.clearGlobalSuccessMsg}
                        />
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export function mapStateToProps(state) {
    return {
        loading: state.globalInfo.loading,
        userInfo: state.adminData.userInfo,
        isSubmittedForm: state.adminData.isSubmittedForm,
        contractorSelection: state.adminData.contractorSelection,
        savedForms: state.draftListInfo.draftList,
        activeScreen: state.globalInfo.activeScreen,
        screenResolution: state.globalInfo.screenResolution,
        formId: state.dynamicFormInfo.formId,
        warrantyId: state.dynamicFormInfo.warrantyId,
        formData: state.dynamicFormInfo.warrantyInfo,
        error: state.globalInfo.globalError,
        successMessage: state.globalInfo.successMessage,
        transactionData: state.payments.transactionData || state.thankYouInfo.transactionData,
        totalCount: state.myCartInfo.totalCount || 0,
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        adminActions: bindActionCreators(adminActionCreators, dispatch),
        draftListActions: bindActionCreators(draftListActionCreators, dispatch),
        submittedListActions: bindActionCreators(submittedListActionCreators, dispatch),
        globalActions: bindActionCreators(globalActionsCreators, dispatch),
        dynamicFormActions: bindActionCreators(dynamicFormActionCreators, dispatch),
        paymentActions: bindActionCreators(TransactionActionCreator, dispatch),
    };
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Header);
